var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.edit)?_c('el-input',{style:({width:_vm.width + 'px'}),attrs:{"size":"small","placeholder":"请输入内容"},model:{value:(_vm.openCardDialog),callback:function ($$v) {_vm.openCardDialog=$$v},expression:"openCardDialog"}}):_c('span',[_vm._v(_vm._s(_vm.input))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dfdedc6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pageConfig/pageInput.vue
// module id = null
// module chunks = 